import React from "react";
import { Link } from "react-router-dom";
import LegalPageLayout from "./LegalPageLayout";
import C from "./legal.config";

export default function SubscriptionTerms() {
  const pp = C.pricing.pro_player;
  const pl = C.pricing.pro_league;
  return (
    <LegalPageLayout title="Subscription Terms" version={C.versions.subscriptions}>
      <p>
        These terms cover the paid subscriptions sold on LEAGUE HUB.
        They supplement the{" "}
        <Link to="/legal/terms" className="underline">Terms of Service</Link>{" "}
        and the{" "}
        <Link to="/legal/withdrawal" className="underline">Cancellation &amp; Refunds</Link> page.
      </p>

      <h2 className="legal-h2">1. Plans &amp; pricing</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>PRO Player</strong> — {pp.amount} {pp.currency} / {pp.interval}. Unlocks AI avatar &amp; banner generation, expanded badges, and premium profile features.</li>
        <li><strong>PRO League</strong> — {pl.amount} {pl.currency} / {pl.interval}. Lets you host a PRO ladder with tournament tools, MMR, and a custom landing page.</li>
      </ul>
      <p>
        Prices shown are in {pp.currency} unless otherwise stated and
        are exclusive of any sales tax (e.g. GST/HST/QST) that may
        apply to your jurisdiction. Stripe will collect and display
        applicable tax at checkout.
      </p>

      <h2 className="legal-h2">2. Auto-renewal</h2>
      <p>
        Subscriptions <strong>renew automatically</strong> at the start
        of each billing period at the then-current price until you
        cancel. Your payment method is stored by Stripe and charged
        on the renewal date.
      </p>

      <h2 className="legal-h2">3. Price changes</h2>
      <p>
        If we change the price of an active subscription, we will give
        you at least <strong>30 days' notice</strong> by email and
        in-app banner before the new price takes effect. You may
        cancel at any time before the renewal to avoid the new charge.
      </p>

      <h2 className="legal-h2">4. Cancellation</h2>
      <p>
        Cancel anytime via <em>Profile → Billing → Manage subscription</em>{" "}
        (Stripe Customer Portal). On cancellation:
      </p>
      <ul className="list-disc pl-5 space-y-1">
        <li>You retain PRO features until the end of the billing period you have already paid for.</li>
        <li>No further charges will be made.</li>
        <li>League-level PRO features (custom landing page, tournament tools) enter a 7-day grace period; if you have not re-subscribed by then, the league reverts to FREE Casual mode and its public landing page becomes the standard cards-only view.</li>
      </ul>
      <p>
        Your specific consumer-cancellation rights — including any
        statutory cooling-off period under the consumer-protection
        legislation of your province or country — are described on the{" "}
        <Link to="/legal/withdrawal" className="underline">Cancellation &amp; Refunds</Link> page.
      </p>

      <h2 className="legal-h2">5. Promo &amp; redeem codes</h2>
      <p>
        We may issue single-use promotional codes that grant a fixed
        amount of PRO time (e.g. 30 days). Codes are non-transferable,
        not redeemable for cash, and may be revoked if obtained
        fraudulently.
      </p>

      <h2 className="legal-h2">6. Failed payments</h2>
      <p>
        If Stripe cannot collect a renewal payment (expired card,
        insufficient funds) we will retry for up to 7 days. After
        that the subscription lapses and PRO features are revoked
        until you complete payment.
      </p>

      <h2 className="legal-h2">7. Disputes &amp; chargebacks</h2>
      <p>
        If you believe a charge is incorrect, please contact us at{" "}
        <a href={`mailto:${C.contact_email}`}>{C.contact_email}</a>{" "}
        before initiating a chargeback. Initiating a chargeback
        without contacting us first may result in account suspension
        pending resolution.
      </p>

      <p className="text-white/45 text-xs">
        Last updated: {C.last_updated}.
      </p>
    </LegalPageLayout>
  );
}
